import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserProfile } from '../../../../model/src/lib/user-profile.model';
import { AppConfig } from '../../../config/app.config';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { DropdownOptionsService } from '../../../core/services/dropdown-options.service';
import { HeaderService } from '../../../core/services/header.service';
import { MenuService } from '../../../core/services/menu.service';
import { StorageService } from '../../../core/services/storage.service';
import { Configuration } from './../../../config/configuration';

@Component({
  selector: 'sigv-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  isVisible = true;
  locale = '';
  currentLanguageLabel = '';
  languageOptions: SelectItem[] = [];
  currentUser?: UserProfile;
  isAzureADEnable: boolean;

  private readonly destroy$ = new Subject();

  constructor(
    private router: Router,
    private menuService: MenuService,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
    private configuration: Configuration,
    private storageService: StorageService,
    private headerService: HeaderService,
    private appConfig: AppConfig,
    private dropdownOptionsService: DropdownOptionsService
  ) {
    this.languageOptions = appConfig.languageList.map(x => ({ label: x.name, value: x.value }));
    this.locale = this.storageService.lang.getItem() || 'en';
    this.currentLanguageLabel =
      this.languageOptions.find((item) => item.value === this.locale)?.label ||
      'English';
    this.isAzureADEnable = this.appConfig.getAzureAD().enabled;
  }

  ngOnInit(): void {
    this.headerService
      .getHeaderObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (isOpen) => {
          this.isVisible = isOpen;
        },
      });
    this.authenticationService.currentUser
      .pipe(takeUntil(this.destroy$))
      .subscribe((currentUser) => {
        if (currentUser) {
          this.currentUser = currentUser;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleSideMenu(): void {
    this.menuService.toggleSideMenu();
  }

  changeLanguage(event: any, languageOption: SelectItem): void {
    event.preventDefault();
    this.locale = languageOption.value;
    this.currentLanguageLabel = languageOption.label || '';
    this.translateService.use(this.locale);
    this.storageService.lang.setItem(this.locale);
  }

  logout(): void {
    this.authenticationService.logout();
    this.router.navigate([this.configuration.routePath.login]);
  }

  goHome(): void {
    if (this.router.url === this.configuration.routePath.index) {
      // 在原頁面時，先跳轉至 /no-permission 再跳轉回原路徑
      this.router
        .navigateByUrl('/no-permission', { skipLocationChange: true })
        .then(() => this.router.navigateByUrl(this.configuration.routePath.index));
    } else {
      this.router.navigate([this.configuration.routePath.index]);
    }
  }

  // 導入 portal click 事件
  portalBtnClick(): void {
    this.dropdownOptionsService.getCommonDropdownOptions('CountryPortalUrl')
      .subscribe(result => {
        const url = result[0].dropdown.name;
        window.open(url, '_blank');
      });
  }
}
